/** Angular dependencies  */
import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable, Subscription, } from 'rxjs';
import { Store } from '@ngrx/store';
import { Location } from '@angular/common';
/** In App dependencies  */
import * as UserDataConfig from '../../config/user-data.config';
import { AppState } from '../../../../store/state/app.state';
import { AnnuitantDoctor, DependantDoctor } from '../../../../model/ngrx/health-records.model';
import * as HealthRecordsActions from '../../../../store/actions/health-records.actions';
import { ApplicationDataCaptureService } from 'src/app/shared/services/api-services/application-datacapture.service';
import { UtilService } from 'src/app/shared/services/api-services/util.service';
import { AnalyticsService, FormValidationsService, SERVICE_END_POINT, DealPartnerFunctionalityService, AuthService } from '../../../../shared';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import { quoteLevelConstants } from '../../../../shared/constants/attribute-values.constants';
import * as DepHealthRecordsActions from '../../../../store/actions/dep-health-records.actions';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

@Component({
  selector: 'app-health-records',
  templateUrl: './health-records.component.html',
  styleUrls: ['./health-records.component.scss']
})


export class HealthRecordsComponent implements OnInit, OnDestroy {

  healthRecordsForm: UntypedFormGroup;
  annuitantDoctorDetails: AnnuitantDoctor;
  annuitantDoctorDetailsStore: Observable<AnnuitantDoctor[]>;

  private countriesList;
  private subscriptn: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  private countryName: string;
  private payload;
  private addressFlag: boolean = false;
  public addressSearchEnabled = false;
  private editMode: boolean;
  private overseasCustomer: boolean;
  private isOverseasDoctor = false;
  private annuitantRiskQAnswer;

  public userInputDetail = UserDataConfig.ElementsConfig;
  public buttonConfig = this.userInputDetail.buttonConfig;
  public addressLine1CodeConfig = this.userInputDetail.addressLine1Config;
  public addressLine2CodeConfig = this.userInputDetail.addressLine2Config;
  public addressLine3CodeConfig = this.userInputDetail.addressLine3Config;
  public addressLine4CodeConfig = this.userInputDetail.addressLine4Config;
  public emailTextCodeConfig = this.userInputDetail.emailTextConfig;
  public mobilePhoneCodeConfig = this.userInputDetail.contactNumberConfig;
  protected countryConfig = this.userInputDetail.countryConfig;
  public postCodeConfig = this.userInputDetail.postCodeConfig;
  protected overseasPostCodeConfig = this.userInputDetail.overseasPostCodeConfig;
  public contentData;
  private responseApplicationData: any;
  private responseApplicationDataStore: Observable<any[]>;
  displayBeneficiaryDetails: boolean = false;

  resultQuote: {};
  quoteDependantDetails: {};
  public showAddress = false;
  CMSData;
  quoteFundInfo;
  resPensionSavings;

  //Variables to access DependantDoctor Store
  dependantDoctorDetails: DependantDoctor;
  dependantDoctorDetailsStore: Observable<DependantDoctor[]>;

  //Similarity Address Indicator for Personal & Dependant Doctors
  isAddressSame: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private _location: Location,
    public el: ElementRef,
    private store: Store<AppState>,
    private applicationDatacaptureService: ApplicationDataCaptureService,
    private router: Router,
    private utilService: UtilService,
    private authService: AuthService,
    private analyticsService: AnalyticsService) {
    this.emailTextCodeConfig.required = false;
    this.contentData = this.route.snapshot.data.contentData.healthRecords;
    this.annuitantDoctorDetailsStore = store.select(STORE_VAL.annuitant_doctor_details);
    this.annuitantDoctorDetailsStore.subscribe((val) => {
      if (val) {
        if (val.length > 0) {
          this.annuitantDoctorDetails = val[0];
          // this.userFormData();
        } else if (this.healthRecordsForm) {
          this.healthRecordsForm.reset();
        }
      }
    });

    // Capturing Dependant Doctor Store Data
    this.dependantDoctorDetailsStore = store.select(STORE_VAL.dependant_doctor_details);
    this.dependantDoctorDetailsStore.subscribe((val) => {
      if (val) {
        if (val.length > 0) {
          this.dependantDoctorDetails = val[0];
          // this.userFormData();
        } else if (this.healthRecordsForm) {
          this.healthRecordsForm.reset();
        }
      }
    });

    // capturing quote journey dependant's details
    store.select(STORE_VAL.dependant_details).subscribe(res => {
      if (res.length > 0) {
        this.quoteDependantDetails = res[0];
      }
    });
    // capturing quote result data
    store.select(STORE_VAL.quote_result).subscribe(res => {
      if (res.length > 0) {
        this.resultQuote = res[0];
      }
    });

    /*  getting values stored in applicationDataResponse store to display beneficiary page */
    this.responseApplicationDataStore = this.store.select(STORE_VAL.application_data_response);
    this.responseApplicationDataStore.subscribe((val) => {
      if (val.length > 0) {
        this.responseApplicationData = val[0];
        this.displayBeneficiaryDetails = val[0]['showBeneficiary'];
        this.quoteFundInfo = (this.responseApplicationData && this.responseApplicationData.quoteFundInfo
          && this.responseApplicationData.quoteFundInfo.length > 0)
          ? this.responseApplicationData.quoteFundInfo[0] : null;
        this.resPensionSavings = this.responseApplicationData.cedingPension[0];
        //console.log(this.displayBeneficiaryDetails);
        //console.log("response to check beneficiary flag", this.responseApplicationData);
      } else if (val.length === 0) {
        this.responseApplicationData = val;
      }
    });

  }

  /** Angular lifecycle hooks block  */
  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.addressSearchEnabled = true;
    this.getCountriesList();
    this.updatingConfigValues();
    this.onLoadPayloadMapper();
    this.userFormData();
    // tslint:disable-next-line:max-line-length
    this.subscripSaveProgress = this.applicationDatacaptureService.subsVar = this.applicationDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    // tslint:disable-next-line:max-line-length
    this.subscripLogout = this.applicationDatacaptureService.subsVar = this.applicationDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });
    const obj = new ParentFormAndElmModel(this.healthRecordsForm, this.el, null, null);
    this.utilService.setParentFormToValidate(obj);
  }
  ngOnDestroy() {
    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
    this.utilService.setParentFormToValidate(null);
  }

  /** End of Angular lifecycle hooks block  */

  /** userFormData(): adds field level validations to each form control in the form group 
    * the reactive form */
  userFormData = () => {
    if (this.annuitantDoctorDetails && !this.checkProperties(this.annuitantDoctorDetails)) {
      // defect 2806 : addressline2 optional and address data retention
      this.addressSearchEnabled = false; // -> to show address line fields and hide address search field
      this.showAddress = true; // -> to show address line fields
      this.isOverseasDoctor = this.annuitantDoctorDetails.ukAddressIndicator &&
        this.annuitantDoctorDetails.ukAddressIndicator === 'N' ? true : false; // -> to hide/show Country code dropdown
      this.healthRecordsForm = this.fb.group({
        annReportViewReqInd: [this.annuitantDoctorDetails.annReportViewReqInd, Validators.required],
        postcode: [this.annuitantDoctorDetails.postcode],
        addressline1: [this.annuitantDoctorDetails.addressline1],
        addressline2: [this.annuitantDoctorDetails.addressline2],
        addressline3: [this.annuitantDoctorDetails.addressline3],
        addressline4: [this.annuitantDoctorDetails.addressline4],
        countryCode: [this.setCountryName(this.annuitantDoctorDetails.countryCode) ? this.setCountryName(this.annuitantDoctorDetails.countryCode) : null],
        ukaddressIndicator: [this.annuitantDoctorDetails.ukAddressIndicator, Validators.required],
        emailAddress: [this.annuitantDoctorDetails.emailAddress],
        mobilePhone: [this.annuitantDoctorDetails.contactNumber, Validators.required]
      });

      if (this.annuitantDoctorDetails.addressline1 && this.addressLine1CodeConfig.value == "") {
        this.addressLine1CodeConfig.value = this.annuitantDoctorDetails.addressline1;
      }

      if (this.annuitantDoctorDetails.addressline2 && this.addressLine2CodeConfig.value == "") {
        this.addressLine2CodeConfig.value = this.annuitantDoctorDetails.addressline2;
      }

      if (this.annuitantDoctorDetails.addressline3 && this.addressLine3CodeConfig.value == "") {
        this.addressLine3CodeConfig.value = this.annuitantDoctorDetails.addressline3;
      }

      if (this.annuitantDoctorDetails.addressline4 && this.addressLine4CodeConfig.value == "") {
        this.addressLine4CodeConfig.value = this.annuitantDoctorDetails.addressline4;
      }

      if (this.annuitantDoctorDetails.postcode && this.postCodeConfig.defaultValue == "") {
        this.postCodeConfig.defaultValue = this.annuitantDoctorDetails.postcode;
      }

      if (this.annuitantDoctorDetails.countryCode) {
        this.healthRecordsForm.controls['countryCode'].setValue(this.setCountryName(this.annuitantDoctorDetails.countryCode));
      }

    } else {
      this.healthRecordsForm = this.fb.group({
        annReportViewReqInd: ['', Validators.required],
        postcode: ['', Validators.required],
        addressline1: ['', Validators.required],
        addressline2: [''],
        addressline3: [''],
        addressline4: [''],
        countryCode: [''],
        ukaddressIndicator: ['', Validators.required],
        emailAddress: [''],
        mobilePhone: ['', Validators.required]
      });
    }
  }

  updatingConfigValues() {
    this.addressLine1CodeConfig.value = this.annuitantDoctorDetails && this.annuitantDoctorDetails.addressline1 ? this.annuitantDoctorDetails.addressline1 : null;
    //this.addressLine1CodeConfig.maxlength = null;
    this.addressLine2CodeConfig.value = this.annuitantDoctorDetails && this.annuitantDoctorDetails.addressline2 ? this.annuitantDoctorDetails.addressline2 : null;
   // this.addressLine2CodeConfig.maxlength = null;
    this.addressLine3CodeConfig.value = this.annuitantDoctorDetails && this.annuitantDoctorDetails.addressline3 ? this.annuitantDoctorDetails.addressline3 : null;
    //this.addressLine3CodeConfig.maxlength = null;
    this.addressLine4CodeConfig.value = this.annuitantDoctorDetails && this.annuitantDoctorDetails.addressline4 ? this.annuitantDoctorDetails.addressline4 : null;
   // this.addressLine4CodeConfig.maxlength = null;
    this.postCodeConfig.defaultValue = this.annuitantDoctorDetails && this.annuitantDoctorDetails.postcode ? this.annuitantDoctorDetails.postcode : null;
    this.emailTextCodeConfig.value = this.annuitantDoctorDetails && this.annuitantDoctorDetails.emailAddress ? this.annuitantDoctorDetails.emailAddress : null;
    this.mobilePhoneCodeConfig.value = this.annuitantDoctorDetails && this.annuitantDoctorDetails.contactNumber ? this.annuitantDoctorDetails.contactNumber : null;
    this.countryName = this.annuitantDoctorDetails && this.annuitantDoctorDetails.countryCode ? this.setCountryName(this.annuitantDoctorDetails.countryCode) : null;
    let val = this.annuitantDoctorDetails && this.annuitantDoctorDetails.annReportViewReqInd ? this.annuitantDoctorDetails.annReportViewReqInd : null;
    this.toggleRiskQuestions(val);
  }


  checkProperties = (obj) => {
    for (const key in obj) {
      if (obj[key] !== null && obj[key] !== '') {
        return false;
      }
    }
    return true;
  }

  OnBackClick() {
    // adding form to store
    this.payloadMapper();
    this.store.dispatch(new HealthRecordsActions.RemoveHealthRecords(0));
    this.store.dispatch(new HealthRecordsActions.AddHealthRecords(this.payload));
  }

  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
  }

  toggleFlag() {
    this.addressFlag = !this.addressFlag;
  }

  toggleContainer(data) {
    // To check whether the dependant's doctor address is "Same As Mine"
    this.checkSimilarAddress();
    if (data === 'Y') {
      this.healthRecordsForm.get('ukaddressIndicator').setValue('Y');
      this.healthRecordsForm.controls['postcode'].setValidators([Validators.required]);
      this.overseasCustomer = false;
      this.addressSearchEnabled = true;
      this.isOverseasDoctor = false;
      this.showAddress = true;
      // defect 2806 - Address Line2 is mandatory only for OverseasCustomer
      this.healthRecordsForm.controls['addressline2'].clearValidators();
      this.addressLine2CodeConfig.required = false;
    } else {
      this.healthRecordsForm.get('ukaddressIndicator').setValue('N');
      // remove validation
      this.healthRecordsForm.controls['postcode'].clearValidators();
      this.healthRecordsForm.get('postcode').setValue('');
      this.overseasCustomer = true;
      this.addressSearchEnabled = false;
      this.isOverseasDoctor = true;
      this.showAddress = true;
      // defect 2806 - Address Line2 is mandatory only for OverseasCustomer
      this.healthRecordsForm.controls['addressline2'].setValidators(Validators.required);
      this.addressLine2CodeConfig.required = true;
    }
    if (this.editMode) {
      // this.showChangeAlert();
    }

  }

  checkSimilarAddress() {
    // This functions checks whether the address record is same for dependant doctor
    if (this.dependantDoctorDetails && (this.healthRecordsForm.get('addressline1').value === this.dependantDoctorDetails.addressline1) &&
      (this.healthRecordsForm.get('postcode').value === this.dependantDoctorDetails.postcode || 
      this.healthRecordsForm.get('countryCode').value === this.dependantDoctorDetails.countryCode)) {
      this.isAddressSame = true;
    } else {
      this.isAddressSame = false;
    }
  }

  onManualClick() {
    //this.healthRecordsForm.reset();
    this.addressSearchEnabled = !this.addressSearchEnabled;
    this.isOverseasDoctor = false;
  }
  onAddressSearchClick() {
    this.addressSearchEnabled = !this.addressSearchEnabled;
    this.addressLine1CodeConfig.value = '';
    this.addressLine2CodeConfig.value = '';
    this.addressLine3CodeConfig.value = '';
    this.addressLine4CodeConfig.value = '';
    this.postCodeConfig.defaultValue = '';
    this.isOverseasDoctor = false;
  }

  /** Receives the formatted address from the QAS Service in case of UK resident */
  onSelectedAddress(formattedAddress) {
    this.addressLine1CodeConfig.value = (formattedAddress[0]['addressLine1'] && (formattedAddress[0]['addressLine1']).length > 35) ? (formattedAddress[0]['addressLine1']).substr(0,35) : formattedAddress[0]['addressLine1'];
    this.addressLine2CodeConfig.value = (formattedAddress[1]['addressLine2'] && (formattedAddress[1]['addressLine2']).length > 35) ?(formattedAddress[1]['addressLine2']).substr(0,35) :  formattedAddress[1]['addressLine2'];
    this.addressLine3CodeConfig.value = (formattedAddress[2]['addressLine3'] && (formattedAddress[2]['addressLine3']).length > 35) ? (formattedAddress[2]['addressLine3']).substr(0,35) : formattedAddress[2]['addressLine3'];
    this.addressLine4CodeConfig.value = (formattedAddress[3]['locality'] && (formattedAddress[3]['locality']).length > 35 ) ? (formattedAddress[3]['locality']).substr(0,35) : formattedAddress[3]['locality'];
    this.postCodeConfig.defaultValue = formattedAddress[5]['postalCode'];
    this.addressSearchEnabled = false;
    if (formattedAddress[6]['country'] === 'UNITED KINGDOM') {
      this.isOverseasDoctor = false;
    } else {
      this.isOverseasDoctor = true;
    }
    //this.payloadMapper();
  }

  /** Creates the payload to store and POST it to the service */
  payloadMapper() {
    this.payload = new AnnuitantDoctor();
    if (this.isOverseasDoctor) {
      this.payload.addressline1 = this.addressLine1CodeConfig.value ? this.addressLine1CodeConfig.value : null;
      this.payload.addressline2 = this.addressLine2CodeConfig.value ? this.addressLine2CodeConfig.value : null;
      this.payload.addressline3 = this.addressLine3CodeConfig.value ? this.addressLine3CodeConfig.value : null;
      this.payload.addressline4 = this.addressLine4CodeConfig.value ? this.addressLine4CodeConfig.value : null;
      this.payload.postcode = this.postCodeConfig.defaultValue ? this.postCodeConfig.defaultValue : null;
      this.payload.countryCode = this.getCountryCodeVal(this.healthRecordsForm.value.countryCode) ? this.getCountryCodeVal(this.healthRecordsForm.value.countryCode) : null;
      this.payload.annReportViewReqInd = this.getRiskQAnswer() ? this.getRiskQAnswer() : null;
      this.payload.emailAddress = this.emailTextCodeConfig.value ? this.emailTextCodeConfig.value : null;
      this.payload.contactNumber = this.mobilePhoneCodeConfig.value ? this.mobilePhoneCodeConfig.value : null;
      this.payload.ukAddressIndicator = this.overseasCustomer ? 'N' : 'Y';
    } else {
      this.payload.addressline1 = this.addressLine1CodeConfig.value ? this.addressLine1CodeConfig.value : null;
      this.payload.addressline2 = this.addressLine2CodeConfig.value ? this.addressLine2CodeConfig.value : null;
      this.payload.addressline3 = this.addressLine3CodeConfig.value ? this.addressLine3CodeConfig.value : null;
      this.payload.addressline4 = this.addressLine4CodeConfig.value ? this.addressLine4CodeConfig.value : null;
      this.payload.postcode = this.postCodeConfig.defaultValue ? this.postCodeConfig.defaultValue : null;
      this.payload.annReportViewReqInd = this.getRiskQAnswer() ? this.getRiskQAnswer() : null;
      this.payload.emailAddress = this.emailTextCodeConfig.value ? this.emailTextCodeConfig.value : null;
      this.payload.contactNumber = this.mobilePhoneCodeConfig.value ? this.mobilePhoneCodeConfig.value : null;
      this.payload.ukAddressIndicator = this.overseasCustomer ? 'N' : 'Y';
    }
  }

  onLoadPayloadMapper() {
    this.payload = new AnnuitantDoctor();
    this.payload.addressLine1 = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.addressline1) ? this.annuitantDoctorDetails.addressline1 : null;
    this.payload.addressLine2 = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.addressline2) ? this.annuitantDoctorDetails.addressline2 : null;
    this.payload.addressLine3 = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.addressline3) ? this.annuitantDoctorDetails.addressline3 : null;
    this.payload.addressLine4 = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.addressline4) ? this.annuitantDoctorDetails.addressline4 : null;
    this.payload.postcode = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.postcode) ? this.annuitantDoctorDetails.postcode : null;
    this.payload.depReportViewReqInd = this.getRiskQAnswer() ? this.getRiskQAnswer() : null;
    this.payload.emailAddress = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.emailAddress) ? this.annuitantDoctorDetails.emailAddress : null;
    this.payload.contactNumber = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.contactNumber) ? this.annuitantDoctorDetails.contactNumber : null;
    this.payload.ukAddressIndicator = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.ukAddressIndicator)
      ? this.annuitantDoctorDetails.ukAddressIndicator : null;
    this.countryName = this.payload.countryCode = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.countryCode) ? this.setCountryName(this.annuitantDoctorDetails.countryCode) : null;
  }

  backtoPrevious() {
    this.store.dispatch(new HealthRecordsActions.RemoveHealthRecords(0));
    this.store.dispatch(new HealthRecordsActions.AddHealthRecords(this.payload));
    this._location.back();
  }

  gotoNext() {
    if (this.healthRecordsForm.valid) {
      this.payloadMapper();
      this.saveFormValues();
      this.applicationDatacaptureService.postApplicationDataCapture(true).subscribe(res => {
        //console.log("Response from backend", res);
        /** DTC-295 Req : Navigates to Dependant details only when product selected is LTA and dependant's question is Yes */
        if (res.secondLife !== null && res.secondLife.dateOfBirth !== null) {
          // if (res.secondLife.dateOfBirth) {
          // tslint:disable-next-line:max-line-length
          /* if (this.resultQuote['product'] === 'C' && (this.responseApplicationData && this.responseApplicationData[0].secondLife)) {  */
            if (this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes
            && DealPartnerFunctionalityService.gmpMaritalCheck(res['customer']['maritalStatus'])) {
            this.router.navigate(['apply/your-dependant-details']);
          } else if (DealPartnerFunctionalityService.isGARProduct(this.resultQuote['garIndicator'])
            && DealPartnerFunctionalityService.gmpMaritalCheck(res['customer']['maritalStatus'])
            && DealPartnerFunctionalityService.spouseBenefit(this.quoteFundInfo, this.responseApplicationData['secondLife'])
            && this.resPensionSavings.productCode && this.resPensionSavings.productCode === "J10") {
            this.router.navigate(['apply/your-pension-savings']);
          } else if (this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes
            && !DealPartnerFunctionalityService.gmpMaritalCheck(res['customer']['maritalStatus'])) {
            this.router.navigate(['apply/your-pension-savings']);
          } else {
            this.router.navigate(['apply/your-dependant-details']);
          }
          // }
        } else {
          this.router.navigate(['apply/your-pension-savings']);
        }
        //} 
        // TODO: as pension saving page is not devloped yet ,so implemeting this beneficiary route here..after developement of pension-saving it will be removed.

        // else if (this.displayBeneficiaryDetails) {
        //   // TODO: as per DTC-292 , this needs to be navigated to the Pension savings screen, not payment details
        //   this.router.navigate(['apply/your-beneficiary-details']);
        //   //console.log('Not Valid', this.healthRecordsForm);
        // }
        // else {
        //   this.router.navigate(['apply/your-payment-details']);
        // }
      });
    } else {
      FormValidationsService.validateAllFormFields(this.healthRecordsForm, this.analyticsService);
      setTimeout(() => {
        this.scrollInvalidForm();
      }, 0);
    }
  }
  getCountriesList() {
    this.utilService.getCountryNames().subscribe(data => {
      if (data) {
        this.countriesList = data;
        this.countryName = ( this.annuitantDoctorDetails && this.annuitantDoctorDetails.countryCode ) ? 
        this.setCountryName(this.annuitantDoctorDetails.countryCode) : null;
      }
    });
  }

  countryMapper() {
    this.countryConfig.options = this.countriesList;
  }

  getCountryCodeVal(value) {
    let countryCode: string = null;
    if (this.countriesList && this.countriesList.length > 0) {
      const countryCodeValue = this.countriesList.filter(val => val['description'] == value);
      countryCode = (countryCodeValue && countryCodeValue[0] && countryCodeValue[0]['key']) ? countryCodeValue[0]['key'] : '';
    }
    return countryCode;
  }
  setCountryName(value) {
    let countryName: string = null;
    if (this.countriesList && this.countriesList.length > 0) {
      const countryNameValue = this.countriesList.filter(val => val['key'] == value);
      countryName = (countryNameValue && countryNameValue[0] && countryNameValue[0]['description']) ? countryNameValue[0]['description'] : '';
    }
    return countryName;
  }

  toggleRiskQuestions(control) {
    this.annuitantRiskQAnswer = control;
  }
  getRiskQAnswer() {
    return this.annuitantRiskQAnswer;
  }

  saveAfterLogout() {
    this.saveFormValues();
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  saveProgress() {
    this.payloadMapper();
    this.saveFormValues();
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe();
  }
  saveFormValues() {
    //console.log(this.payload);
    if (this.isAddressSame) {
      // This function updates the dependant store if "Same as mine"
      this.updateDependantStore();
    }
    this.store.dispatch(new HealthRecordsActions.RemoveHealthRecords(0));
    this.store.dispatch(new HealthRecordsActions.AddHealthRecords(this.payload));

  }

  updateDependantStore() {
    // Updating the Dependant Doctor Address
    this.dependantDoctorDetails = {...this.dependantDoctorDetails, addressline1: this.payload.addressline1};
    this.dependantDoctorDetails.addressline2 = this.payload.addressline2;
    this.dependantDoctorDetails.addressline3 = this.payload.addressline3;
    this.dependantDoctorDetails.addressline4 = this.payload.addressLine4;
    this.dependantDoctorDetails.countryCode = this.payload.countryCode;
    this.dependantDoctorDetails.postcode = this.payload.postcode;
    this.dependantDoctorDetails.ukAddressIndicator = this.payload.ukAddressIndicator;
    this.store.dispatch(new DepHealthRecordsActions.RemoveDepHealthRecords(0));
    this.store.dispatch(new DepHealthRecordsActions.AddDepHealthRecords(this.dependantDoctorDetails));
  }

  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_DoctorsDetailsApply;
    //console.log('changed value = ', );
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.contentData.header = this.CMSData.string_DoctorsDetailsTitle;
        this.contentData.lifestyleInfoText = this.CMSData.string_DoctorsDetailsSubtitle;
        this.contentData.subtitle = this.CMSData.string_UkDoctorInformation;
        this.contentData.sensitiveDataTitle = this.CMSData.commonBlock.string_SensitiveDataTitle;
        this.userInputDetail.radioButtonIsDoctorUKAddressConfig.questionStatement = this.CMSData.string_UKDoctorQuestion;
        this.userInputDetail.radioButtonIsDoctorUKAddressConfig.infoIconData.content = this.CMSData.string_UkDoctorInformation;
        this.contentData.sensitiveDataText = this.CMSData.html_SensitiveDataIntroductionAnnuitant;
        this.contentData.medReportQuestion.questionStatement = this.CMSData.commonBlock.string_ViewReportQuestion;
        this.contentData.notification = this.CMSData.string_InformationSupported;
      }
    });
  }
  /** End of code block for CMS */
}
